import styles from './styles/title-styles.component.module.css';

interface ITtitleProps {
	children: React.ReactNode;
}

export default function Title({ children }: ITtitleProps) {
	return <p className={styles.title}>{children}</p>;
}
